<template>
  <AppModal
    class="upload-metadata-file-modal"
    :disabled="isSubmitting"
    @close="$emit('close')"
  >
    <template #header>
      Upload Metadata
    </template>

    <FileInput
      required
      :processing="isSubmitting"
      :validation-error="errors || validationError"
      accept="text/csv"
      @file-uploaded="handleChange"
    />

    <span
      v-if="data.metadata"
      class="block mb-8"
    >
      {{ data.metadata.name }}
    </span>

    <div class="flex gap-3">
      <AppButton
        class="btn-outline btn-secondary w-full max-w-sm"
        @click="$emit('close')"
      >
        Cancel
      </AppButton>

      <AppButton
        class="btn-solid btn-secondary w-full max-w-sm"
        :disabled="data.metadata === null || errors !== null"
        :processing="isSubmitting || processing"
        @click="$emit('upload', data)"
      >
        {{ isSubmitting || processing ? 'Uploading' : 'Upload' }}
      </AppButton>
    </div>
  </AppModal>
</template>

<script setup>
import { reactive, ref } from 'vue';

import {
  AppButton,
  AppModal,
} from '@/components/app';

import { FileInput } from '@/components/forms/inputs';

defineEmits(['upload', 'close']);

defineProps({
  processing: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: String,
    default: null,
  },
});

const errors = ref(null);
const isSubmitting = ref(false);

const data = reactive({ metadata: null });

const handleChange = (e) => {
  errors.value = null;
  const fileInput = e.target;
  const file = fileInput.files.length ? fileInput.files[0] : null;

  if (!file) {
    return;
  }

  data.metadata = file;
};
</script>
